import {useEffect, useState} from 'react';
import Modal from 'antd/es/modal/Modal';
import {
  Card,
  Form,
  Input,
  DatePicker,
  Button,
  Upload,
  Row,
  Col,
  Select,
} from 'antd';
import {CloseCircleFilled, UploadOutlined} from '@ant-design/icons';
import {useDispatch} from 'react-redux';
import {addAds, updateAdById} from '../../../../Store/Actions';
import {
  NoEmptySpaceInput,
  UploadFileMaxSize,
  displayFileName,
  addHttpsToUrl,
  disablePrevDatesHandler,
  validateAdsDescriptionInput,
  validateEmailInput,
  validateMonthsInput,
} from '../../../../Util/commonUtility';
import SectionLayout from '../../../CommonComponents/Layout/sectionLayout';
import {useNavigate} from 'react-router-dom';
import dayjs from 'dayjs';
import {applicationConfig} from '../../../../Util/config';
import {FETCH_ERROR} from '../../../../Constant/ActionTypes';
import useLocalization from '../../../../Localization';

const AdsFormComponent = (props) => {
  const {ApplicationString} = useLocalization();
  const {isModalOpen, setIsModalOpen, editData, adFeesOptions, zeroFeeData} =
    props;
  const [validFileList, setValidFileList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const onFinish = (values) => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    const normalizedAttachmentUrl = values?.attachment_url
      ? addHttpsToUrl(values.attachment_url)
      : '';

    const data = new FormData();

    // editData?.adsLogo
    //   ? editData?.adsLogo?.id === validFileList[0]?.uid
    //     ? data.append('logo_ids', `[${editData?.adsLogo?.id}]`)
    //     : data.append('logos', validFileList[0] || [])
    //   : data.append('logos', validFileList[0] || []);
    data.append('vendor', values.vendor ? values.vendor : '');
    data.append(
      'attachment_url',
      values.attachment_url ? normalizedAttachmentUrl : '',
    );
    data.append('email', values?.email ? values.email : '');
    values.start_date &&
      data.append(
        'start_date',
        values.start_date ? dayjs(values?.start_date).format('YYYY-MM-DD') : '',
      );
    data.append('description', values.description ? values.description : '');
    data.append(
      'ad_fee_id',
      values.ad_fee_id ? parseInt(values.ad_fee_id) : undefined,
    );
    data.append('months', values?.months ? values?.months : '');
    if (editData && editData?.id) {
      dispatch(
        updateAdById(
          data,
          editData?.id,
          form,
          null,
          null,
          setIsModalOpen,
          setIsSubmitting,
        ),
      );
    } else {
      const isZeroFee =
        zeroFeeData?.length > 0
          ? values?.ad_fee_id === zeroFeeData[0]?.id
          : false;
      dispatch(
        addAds(
          data,
          form,
          navigate,
          setIsModalOpen,
          setValidFileList,
          isZeroFee,
          setIsSubmitting,
        ),
      );
    }
    // form.resetFields();
    // setIsModalOpen(false);
  };

  const handleCancel = () => {
    if (isSubmitting) return;
    form.resetFields();
    setIsModalOpen(false);
  };
  const handleClose = () => {
    if (isSubmitting) return;
    form.resetFields();
    setIsModalOpen(false);
    setValidFileList((prev) => []);
  };
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };
  const dummyRequest = ({file, onSuccess}) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  const filesFormats = ['image/png', 'image/jpeg', 'image/jpg'];

  const uploadProps = {
    name: 'file',
    multiple: true,
    maxCount: 10,
    // listType: 'picture',
    beforeUpload: (file) => {
      const isRightFormat = filesFormats.includes(file.type);
      if (!isRightFormat) {
        dispatch({
          type: FETCH_ERROR,
          payload: 'Accepted file formats: JPG and PNG only',
        });
        return;
      }
      const isLt2M = file.size / 1024 / 1024 < UploadFileMaxSize;
      if (!isLt2M) {
        dispatch({
          type: FETCH_ERROR,
          payload: `File must smaller than ${UploadFileMaxSize}MB.`,
        });
        return false;
      }
      if (file?.type?.includes('image')) {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = URL.createObjectURL(file);
          img.onload = () => {
            if (img.width >= 200 && img.height >= 200) {
              setValidFileList((prev) => [file]);
              resolve(isRightFormat && isLt2M);
            } else {
              dispatch({
                type: FETCH_ERROR,
                payload: 'Image size must be greater than 200x200 pixels.',
              });
              setValidFileList((prev) =>
                prev.filter((f) => f.uid !== file.uid),
              );
              reject();
            }
          };
          img.onerror = reject;
        });
      } else {
        setValidFileList((prev) => [file]);
        return isRightFormat && isLt2M;
      }
    },
  };

  const removeFileHandler = (file) => {
    setValidFileList((prevFileList) => {
      return prevFileList.filter((item) => item?.uid !== file?.uid);
    });
  };

  useEffect(() => {
    if (editData) {
      const adFeeId = adFeesOptions?.find(
        (obj) => obj?.details === editData?.ad_fee_note,
      )?.id;
      form.setFieldsValue({
        vendor: editData?.adsHeading,
        attachment_url: editData?.url,
        email: editData?.adsEmail,
        description: editData?.adsDescription,

        start_date: editData?.adsStart_date
          ? dayjs(editData?.adsStart_date)
          : null,
        months: editData?.months,
        ad_fee_id: adFeeId,
      });
    }
  });

  useEffect(() => {
    if (isModalOpen) {
      editData?.adsLogo &&
        setValidFileList((prev) => [
          {
            uid: editData?.adsLogo?.id,
            name: displayFileName(editData?.adsLogo),
            status: 'done',
            url: `${applicationConfig.UPLOAD_URL}/${editData?.adsLogo?.name}`,
          },
        ]);
    }
  }, [isModalOpen]);

  return (
    <SectionLayout>
      <div className='form-container'>
        <Modal
          position='center'
          open={isModalOpen}
          className='ads-form-modal'
          prefixCls='customized-modal-v2'
          footer={null}
          onCancel={handleClose}
          closeIcon={
            <CloseCircleFilled
              className='close-icon-modal-v2'
              id='UserAdsComponent-closeButton-addAds'
            />
          }>
          <Card
            title={
              <div className='modal-container-v2'>
                <div>
                  <span className='modal-heading-v2'>
                    {ApplicationString['userAdsFormComponent.heading']}
                  </span>
                </div>
                <div>
                  <span className='modal-desc-v2'>
                    {ApplicationString['userAdsFormComponent.subheading']}
                  </span>
                </div>
              </div>
            }
            bordered={false}
            className='form-card'>
            <div className='main-content-container'>
              <Form onFinish={onFinish} form={form} initialValues={''}>
                <Row>
                  <Col span={24}>
                    <div className='common-input-container-v2'>
                      <Form.Item
                        name='vendor'
                        rules={[
                          {
                            required: true,
                            message:
                              ApplicationString[
                                'userAdsFormComponent.form.validation.vendorName'
                              ],
                          },
                          {
                            validator: (_, value) =>
                              NoEmptySpaceInput(value, 'Advertiser Name'),
                          },
                        ]}>
                        <Input
                          placeholder={
                            ApplicationString[
                              'userAdsFormComponent.form.placeholder.vendorName'
                            ]
                          }
                          className='form-input-v2'
                        />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <Row gutter={15}>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <div className='common-input-container-v2'>
                      <Form.Item
                        name='attachment_url'
                        rules={[
                          {
                            required: true,
                            message:
                              ApplicationString[
                                'userAdsFormComponent.form.validation.attachmentUrl'
                              ],
                          },
                          {
                            type: 'url',
                            message:
                              ApplicationString[
                                'userAdsFormComponent.form.validation.attachmentUrl.invalidFormat'
                              ],
                          },
                        ]}>
                        <Input
                          placeholder={
                            ApplicationString[
                              'userAdsFormComponent.form.placeholder.attachmentURL'
                            ]
                          }
                          title={
                            ApplicationString[
                              'userAdsFormComponent.form.placeholder.attachmentURL'
                            ]
                          }
                          prefixCls='attachment-url-input-v2'
                        />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <div className='common-input-container-v2'>
                      <Form.Item
                        name='email'
                        rules={[
                          {
                            required: true,
                            message:
                              ApplicationString[
                                'userAdsFormComponent.form.validation.email'
                              ],
                          },
                          {
                            validator: (_, value) =>
                              validateEmailInput(value, 'Email'),
                          },
                        ]}>
                        <Input
                          placeholder={
                            ApplicationString[
                              'userAdsFormComponent.form.placeholder.email'
                            ]
                          }
                          title={
                            ApplicationString[
                              'userAdsFormComponent.form.placeholder.email'
                            ]
                          }
                          className='form-input-v2'
                        />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <Row gutter={15}>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <div>
                      {/* <Form.Item
                        name='start_date'
                        prefixCls='form-input-form-item-class'
                        rules={[
                          {
                            required: true,
                            message:
                              ApplicationString[
                                'userAdsFormComponent.form.validation.startDate'
                              ],
                          },
                        ]}>
                        <DatePicker
                          disabledDate={(current) =>
                            disablePrevDatesHandler(current, true)
                          }
                          placeholder={
                            ApplicationString[
                              'userAdsFormComponent.form.placeholder.startDate'
                            ]
                          }
                          prefixCls='form-input-datepicker-v2'
                        />
                      </Form.Item> */}
                      <Form.Item
                        rules={[
                          {
                            required: true,
                            message:
                              ApplicationString[
                                'userAdsFormComponent.form.validation.adType'
                              ],
                          },
                        ]}
                        initialValue={
                          adFeesOptions?.length > 0 && adFeesOptions[0]?.id
                        }
                        name='ad_fee_id'>
                        <Select
                          id='adminAds-adTypeSelect-select'
                          className='form-select-v2'
                          defaultValue={
                            adFeesOptions?.length > 0 && adFeesOptions[0]?.id
                          }
                          value={
                            adFeesOptions?.length > 0 && adFeesOptions[0]?.id
                          }
                          placeholder={
                            ApplicationString[
                              'userAdsFormComponent.form.placeholder.adType'
                            ]
                          }
                          options={adFeesOptions}></Select>
                      </Form.Item>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <div>
                      <Form.Item
                        name={'months'}
                        className='common-input-container-v2'
                        rules={[
                          {
                            required: true,
                            message: '',
                          },
                          {
                            validator: (_, value) =>
                              validateMonthsInput(value, 'Months'),
                          },
                        ]}>
                        <Input
                          placeholder={
                            ApplicationString[
                              'userAdsFormComponent.form.placeholder.months'
                            ]
                          }
                          title={
                            ApplicationString[
                              'userAdsFormComponent.form.placeholder.months'
                            ]
                          }
                          className='form-input-v2'
                        />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <div className='common-input-container-v2'>
                      <Form.Item
                        name='description'
                        rules={[
                          {
                            validator: (_, value) =>
                              validateAdsDescriptionInput(value, 'Description'),
                          },
                        ]}>
                        <Input.TextArea
                          placeholder={
                            ApplicationString[
                              'userAdsFormComponent.form.placeholder.description'
                            ]
                          }
                          className='form-input-v2 form-input-text-area-class'
                          rows={7}
                        />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>

                {/* <Row>
                  <Col span={24}>
                    <div className='common-input-container-v2 upload'>
                      <Form.Item
                        name='file_logo'
                        // valuePropName='fileList'
                        getValueFromEvent={normFile}>
                        <Upload
                          {...uploadProps}
                          accept='image/*'
                          customRequest={dummyRequest}
                          onRemove={removeFileHandler}
                          fileList={validFileList}
                          showUploadList={true}>
                          <div>
                            <UploadOutlined className='upload-logo-v2' />
                            <div>
                              <span className='upload-text-logos-v2'>
                                {
                                  ApplicationString[
                                    'userAdsFormComponent.form.placeholder.uploadLogo'
                                  ]
                                }
                              </span>
                            </div>
                            <div className='upload-type-admin'>
                              <span className='upload-desc-v2'>
                                {
                                  ApplicationString[
                                    'userAdsFormComponent.form.validation.uploadLogo.acceptedFormats'
                                  ]
                                }
                                :
                              </span>
                              <br />
                              <span className='upload-desc-v2'>
                                {ApplicationString[
                                  'userAdsFormComponent.form.validation.uploadLogo.maxSize'
                                ](UploadFileMaxSize)}
                              </span>
                            </div>
                          </div>
                        </Upload>
                      </Form.Item>
                    </div>
                  </Col>
                </Row> */}
                {/* <Divider /> */}
                <div className='modal-footer-container'>
                  <div></div>
                  <div className='modal-footer-button'>
                    <Button
                      htmlType='submit'
                      id='UserAdsComponent-submitButton-addAds'
                      className='checkout-button-v2'
                      loading={isSubmitting}>
                      <span className='checkout-text-v2'>
                        {editData?.id
                          ? ApplicationString[
                              'userAdsFormComponent.form.saveDraft'
                            ]
                          : ApplicationString[
                              'userAdsFormComponent.form.proceed'
                            ]}
                      </span>
                    </Button>
                    <Button
                      id='UserAdsComponent-cancelButton-addAds'
                      className='cancel-button-v2'
                      onClick={handleCancel}
                      disabled={isSubmitting}>
                      <span className='cancel-text-v2'>
                        {ApplicationString['userAdsFormComponent.form.cancel']}
                      </span>
                    </Button>
                  </div>
                </div>
              </Form>
            </div>
          </Card>
        </Modal>
      </div>
    </SectionLayout>
  );
};

export default AdsFormComponent;
